import { Component, OnInit, SimpleChanges } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticatedRouteGuard } from "security/authenticatedRouteGuard.service";
import { KeycloakService } from "security/keycloak.service";

@Component({
  selector: "app-side-nav-items",
  templateUrl: "./side-nav-items.component.html"
})
export class SideNavItemsComponent implements OnInit {

  constructor(
    private roleGuard: AuthenticatedRouteGuard,
    private keycloakService: KeycloakService,
    private router: Router
  ) {}

  ngOnInit(): void {}

}
